/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-07-29 11:03:52
 * @LastEditTime: 2021-07-29 14:40:59
 * @FilePath: /app-teacher-h5/src/service/http.js
 */
import service from './base'
/**
 * 封装get请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise}
 */

/**
 * @param {any} url
 * @param {any} params
 */
const get = (url, params, config = {}) => new Promise((resolve, reject) => {
  service({
    ...config,
    method: 'get',
    url,
    params
  })
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
})

/**
 * 封装post请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

const post = (url, data, config = {}) => new Promise((resolve, reject) => {
  console.log('封装post请求', url)
  service({
    ...config,
    method: 'post',
    url,
    data
  })
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
})

/**
 * 封装post上传文件请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

const postFile = (url, data, config = {}) => new Promise((resolve, reject) => {
  service({
    ...config,
    method: 'post',
    url,
    data,
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    }
  })
    .then(res => {
      resolve(res)
    })
    .catch(error => {
      reject(error)
    })
})

export default {
  get,
  post,
  postFile
}
